import { apiClient } from '../config/ApiClient';
import type { ShippingLabelRequestDTO } from '../dto/shipping/ShippingLabelRequestDTO';
import type { ShippingLabelResponseDTO } from '../dto/shipping/ShippingLabelResponseDTO';

export const createShippingLabel = (req: ShippingLabelRequestDTO) =>
  apiClient.post<ShippingLabelResponseDTO>('/api/shipping/ship', req);
